module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/ortho-test/ortho-field-config-translation.json
// module id = 1217
// module chunks = 0